import { Component, ElementRef, ViewChild, AfterViewInit } from "@angular/core";
import { IAccount } from "./account";
import { FormBuilder } from "@angular/forms";
import { AuthService } from "../../auth.service";
import { HeaderAndNavigationService } from "../headerandnavigation.service";
import { AppCommonService } from "../../appcommon.service";
import { Router } from "@angular/router";
import { OnInit } from "@angular/core/src/metadata/lifecycle_hooks";
import { GlobalService } from "../../global.service";
import { ILoggedUser } from "../loggeduser/loggeduser";

@Component({
  selector: '[mft-accounts]',
  templateUrl: './accounts.component.html'
})
export class AccountsComponent implements OnInit, AfterViewInit {
  @ViewChild('accessAccountsArea') accessAccountsArea: ElementRef;
  accessAccounts: IAccount[];
  loggedUser: ILoggedUser;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    public headerAndNavigationService: HeaderAndNavigationService,
    private appCommonService: AppCommonService,
    private router: Router
  ) { }

    ngOnInit(): void {
        //debugger;
    this.loggedUser = this.headerAndNavigationService.getLoggedUser();
    if (this.loggedUser != null && this.loggedUser != undefined && this.loggedUser.id != null) {
      this.headerAndNavigationService.getAccessAccounts()
        .subscribe(
          (accounts: IAccount[]) => {
            this.accessAccounts = accounts;
            setTimeout(() => {
              let el: HTMLElement = this.accessAccountsArea.nativeElement as HTMLElement;
              this.appCommonService.setAccountsMenuElement(el);
              if (this.router.url === "/home") {
                this.authService.showLoader = false;
              }
            }, 100);
          },
          (error: any) => {
            this.headerAndNavigationService.showError("Access accounts retrieval problem", <any>error)
            if (this.router.url === "/home") {
              this.authService.showLoader = false;
            }
          }
        );
    }
  }

  ngAfterViewInit() {
    //setTimeout(() => {
    //    let el: HTMLElement = this.accessAccountsArea.nativeElement as HTMLElement;
    //    this.appCommonService.setAccountsMenuElement(el);
    //}, 3000);        
  }

  selectAllAccountChange(e) {
    if (e.target.checked) {
      this.accessAccounts.forEach(eachObj => {
        eachObj.selected = true;
      });
    }
    else {
      this.accessAccounts.forEach(eachObj => {
        eachObj.selected = false;
      });
    }
  }

  setSelectedAccounts() {
    let selectedAccessAccounts = this.accessAccounts.filter(x => x.selected === true);
    let userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternalLocalhost")));
    if (userData == undefined) {
      userData = JSON.parse(sessionStorage.getItem(("userData_EServicesExternal")));
    }

    if (userData == null) {
      this.headerAndNavigationService.RedirectToNoaccess();
    }
    else {
      if (selectedAccessAccounts.length > 0) {
        this.authService.setAccessAccounts(this.accessAccounts);
        //this.router.navigate([this.appCommonService.reDirectURL]);
        // clear memory leak 


        let UserId = userData.sub;
        //debugger
        this.authService.ClearMemoryLeak(UserId)
          .subscribe(
            (drawingAccounts: null) => {

            },
            (error: any) => {

            }
          );
        this.appCommonService.accountsMenuManualClick();
        this.router.navigate(['/accountdashboard']);

      }
      else {
        this.headerAndNavigationService.showInfo("Accounts", "Please select at least one account.")
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/accounts/accounts.component.ts